// Datas: chave do dia local e data por extenso.
// Extraído de App.js sem alteração de comportamento.

export const localDayKey = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const fmtDateLong = ts => { try { return ts ? new Date(ts).toLocaleDateString("pt-BR", { day:"numeric", month:"long", year:"numeric" }) : "—"; } catch { return "—"; } };

// Divide um tempo de estudo que termina em `endMs` nos dias (locais) que ele atravessou.
// Ex.: 23h50 → 00h10 (20 min) vira 10 min no dia anterior (às 23:59:59) e 10 min no dia seguinte.
// Tempo negativo (ajuste) não é dividido. Devolve [{ sec, at: Date }] em ordem.
export function splitByMidnight(sec, endMs = Date.now()) {
  if (!(sec > 0)) return [{ sec, at: new Date(endMs) }];
  const parts = [];
  let left = sec, end = endMs;
  while (left > 0) {
    const d = new Date(end); d.setHours(0, 0, 0, 0);
    const midnight = d.getTime();                       // início do dia em que `end` cai
    const inDay = Math.min(left, Math.max(1, Math.round((end - midnight) / 1000)));
    parts.unshift({ sec: inDay, at: new Date(end) });
    left -= inDay;
    end = midnight - 1000;                              // 23:59:59 do dia anterior
    if (parts.length > 14) { parts[0].sec += left; break; }
  }
  return parts;
}
